module.exports = __webpack_public_path__ + "a2b8c641546c0e5a95e22e5a262f0357.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Light.ttf
// module id = 339
// module chunks = 0